<ng-container *ngIf="mediaType === 'image'">
  <img
    [src]="source"
    [alt]="alt"
    referrerpolicy="no-referrer"
    (load)="loaded = true"
    (error)="loadingFailed()"
  />
</ng-container>

<ng-container *ngIf="mediaType === 'video'">
  <video [controls]="false" (loadeddata)="loaded = true" (error)="loadingFailed()">
    <source [src]="source" type="video/mp4" />
  </video>
  <div class="video-overlay" (click)="openVideoModal()">
    <i nz-icon nzType="play-circle" nzTheme="fill"></i>
  </div>
</ng-container>
